module.exports = __webpack_public_path__ + "ddcd8942bde365d5aa64e3120c571eb5.svg";